import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=72c676ac&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c676ac"]])

export default __exports__